import { useState, useEffect } from "react";
import axios from "axios";
import { Alert, Modal, Col, Row, Form, Button } from "react-bootstrap";

const UserModal = (props) => {
  const API_URL = process.env.REACT_APP_BACKEND_URL + "/api";
  const ls = require("localstorage-ttl");

  const [isLoading, setLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");

  const [userId, setUserId] = useState();
  const [docNumber, setDocNumber] = useState();
  const [lastname, setLastName] = useState();
  const [name, setName] = useState();
  const [email, setEmail] = useState();
  const [birthDate, setBirthDate] = useState();
  const [startDate, setStartDate] = useState();

  const usuario = JSON.parse(ls.get("userData"));
  const token = JSON.parse(ls.get("jwt"));
  const user = props.user;

  useEffect(() => {
    if (user) {
      setUserId(user.id);
      setDocNumber(user.attributes.docNumber);
      setLastName(user.attributes.lastname);
      setName(user.attributes.name);
      setEmail(user.attributes.email);
      setBirthDate(user.attributes.birthDate);
      setStartDate(user.attributes.startDate);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function isIncomplete() {
    return (
      !docNumber ||
      docNumber === "" ||
      !lastname ||
      lastname === "" ||
      !name ||
      name === "" ||
      !birthDate ||
      birthDate === "" ||
      !startDate ||
      startDate === "" ||
      !email ||
      email === "" ||
      (errorMessage !== null && errorMessage !== "")
    );
  }

  const headerRequest = {
    headers: {
      Authorization: `Bearer ${token}`,
    },
  };

  const handleSubmit = async (e) => {
    setLoading(true);
    e.preventDefault();

    let reqUser = {
      data: {
        docNumber,
        lastname: lastname.toUpperCase(),
        name: name.toUpperCase(),
        email: email.toLowerCase(),
        birthDate: birthDate,
        startDate: startDate,
        createdByUser: usuario.id,
      },
    };
    // Si existe en temp-users hacer PUT, sino POST
    if (user) {
      await axios
        .put(`${API_URL}/temp-users/${userId}`, reqUser, headerRequest)
        .then((u) => {
          setLoading(false);
          props.onHide(true);
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error with put temp-users:", error.response);
          setErrorMessage("Hubo un error, intente nuevamente.");
          return;
        });
    } else {
      await axios
        .post(`${API_URL}/temp-users`, reqUser, headerRequest)
        .then((u) => {
          setLoading(false);
          props.onHide(true);
        })
        .catch((error) => {
          setLoading(false);
          console.log("Error with post temp-users:", error.response);
          setErrorMessage("Hubo un error, intente nuevamente.");
          return;
        });
    }
  };

  return (
    <Modal
      {...props}
      backdrop="static"
      aria-labelledby="contained-modal-title-vcenter"
    >
      <Modal.Header closeButton>
        <Modal.Title id="contained-modal-title-vcenter">
          {user ? "Editar" : "Crear"} Alumno
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="show-grid">
        <Form onSubmit={(e) => handleSubmit(e)}>
          <Row className="mb-1">
            <h5>Datos del Alumno</h5>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formDocNumber">
              <Form.Label>Núm. Documento</Form.Label>
              <Form.Control
                type="text"
                placeholder="Núm. Documento"
                value={docNumber}
                inputMode="numeric"
                pattern="[0-9]*"
                maxLength="10"
                onChange={(e) => setDocNumber(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formLastname">
              <Form.Label>Apellido</Form.Label>
              <Form.Control
                type="text"
                placeholder="Apellido"
                value={lastname}
                onChange={(e) => setLastName(e.target.value)}
              />
            </Form.Group>
          </Row>
          <Row className="mb-3">
            <Form.Group as={Col} controlId="formName">
              <Form.Label>Nombres</Form.Label>
              <Form.Control
                type="text"
                placeholder="Nombres"
                value={name}
                onChange={(e) => setName(e.target.value)}
              />
            </Form.Group>
            <Form.Group as={Col} controlId="formEmail">
              <Form.Label>Email</Form.Label>
              <Form.Control
                type="email"
                placeholder="Email"
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Row className="mb-3">
            <Form.Group as={Col} controlId="formBirthDate">
              <Form.Label>Fecha Nacim.</Form.Label>
              <Form.Control
                type="date"
                name="birthDate"
                value={birthDate}
                onChange={(e) => setBirthDate(e.target.value)}
              />
            </Form.Group>

            <Form.Group as={Col} controlId="formStartDate">
              <Form.Label>Fecha Ingreso</Form.Label>
              <Form.Control
                type="date"
                name="startDate"
                value={startDate}
                onChange={(e) => setStartDate(e.target.value)}
              />
            </Form.Group>
          </Row>

          <Button
            variant="primary"
            type="submit"
            disabled={isLoading || isIncomplete()}
          >
            {isLoading ? "Procesando…" : "GRABAR"}
          </Button>
          {errorMessage ? (
            <Alert className="mt-3" variant="danger">
              {errorMessage}
            </Alert>
          ) : (
            <></>
          )}
        </Form>
      </Modal.Body>
    </Modal>
  );
};
export default UserModal;
